import { Input } from "antd";
import styled from "styled-components";

export const Modal = styled.div`
  position: fixed;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 11;
`;
export const ModalBg = styled.div`
  z-index: 8;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed;
`;

export const CloseIcon = styled.div`
  position: absolute;
  z-index: 11;
  top: 31px;
  right: 27px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  @media only screen and (max-width: 1024px) {
    right: 24px;
    top: -16px;
    background-color: white;
    border-radius: 100%;
  }
`;

export const Container = styled.div`
  position: relative;
  width: ${(props) => props.width ?? "600px"};
  z-index: 10;
  margin: 50vh auto auto auto;
  padding: 48px 64px;
  transform: translateY(-50%);
  max-width: 90%;
  &.modal-video-container{
    width: 600px !important;
    padding: 0 !important;
    border-radius: 0 !important;
  }
  @media only screen and (min-width: 1024px) and (max-width: 1366px) {
    width: 714px;
    padding: 24px 64px;
    border-radius: 54px;
    &.modal-video-container{
      width: 600px !important;
      padding: 0 !important;
      border-radius: 0 !important;
    }
  }
  @media only screen and (max-width: 640px) {
    max-width: 335px;
    width: calc(100% - 32px);
    padding: 24px;
    &.modal-video-container{
      width: calc(100% - 32px) !important;
      padding: 0 !important;
      border-radius: 0 !important;
    }
  }

  background: #ffffff;
  box-shadow: 0px 16px 36px rgba(104, 109, 132, 0.4157);
  border-radius: 30px;
  &.modal-mint {
    border-radius: 64px;
    padding: 52px 64px;
    @media only screen and (min-width: 1024px) and (max-width: 1366px) {
      border-radius: 64px;
      padding: 52px 64px;
      width: 850px;
    }
    @media screen and (max-width: 1024px) {
      border-radius: 32px;
    }
    @media only screen and (max-width: 640px) {
      width: 335px;
      padding: 30px 24px;
    }
  }
  &::-webkit-scrollbar {
    display: none;
  }

  & .modal-footer {
    padding: 20px 0 40px 0;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 18px;
    justify-content: center;
    align-items: center;

    & .cancel-btn {
      width: 120px;
      cursor: pointer;
      height: 42px;
      border: none;
      color: #485ea8;
      outline: none;
      background: linear-gradient(157.48deg, #ffffff -5.34%, #ffffff 103.65%);
      box-shadow: 0px 5px 15px rgba(23, 40, 253, 0.333333);
      border-radius: 10px;
    }

    & .confirm-btn {
      width: 120px;
      cursor: pointer;
      height: 42px;
      border: none;
      color: #ffffff;
      outline: none;
      background: linear-gradient(157.48deg, #548feb -5.34%, #4d67c1 103.65%);
      box-shadow: 0px 5px 15px rgba(23, 40, 253, 0.333333);
      border-radius: 10px;
    }
  }
  &.order-detail {
    padding: 30px 0px 0;
    border: 30px;
    margin: 40vh auto auto auto;
    @media screen and (min-width: 1024px) {
      width: 1000px !important;
    }
    @media screen and (min-width: 1366px) {
      width: 1100px !important;
    }
    > div {
      max-height: 90vh;
    }
    .order-modal-body {
      padding-left: 70px;
      padding-right: 60px;
      max-height: calc(100vh - 520px);
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 8px;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #393db8;
      }
      &::-webkit-scrollbar-track {
        background-color: #d9d9d9;
        border-radius: 10px;
      }
    }

    @media screen and (max-width: 1024px) {
      background: #f5f5f5;
      .order-modal-body {
        padding-left: 20px;
        padding-right: 20px;
      }
    }
    @media screen and (max-width: 640px) {
      background: #f5f5f5;
      width: calc(100vw - 30px);
      .order-modal-body {
        padding-left: 15px;
        padding-right: 15px;
      }
    }
  }
`;

export const ContainerWraper = styled.div`
  position: relative;
  width: ${(props) => props.width ?? "600px"};
  z-index: 10;
  margin: 50vh auto auto auto;
  transform: translateY(-50%);
  max-width: 90%;
  @media only screen and (max-width: 640px) {
    width: 335px;
  }

  background: #ffffff;
  box-shadow: 0px 16px 36px rgba(104, 109, 132, 0.4157);
  border-radius: 30px;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Header = styled.div`
  padding: 30px 20px;

  h3 {
    font-weight: 500;
    font-size: 25px;
    line-height: 30px;

    text-align: center;
    letter-spacing: -0.96px;

    color: #F12E11;
  }
`;

export const Body = styled.div`
  padding: 0px 60px;
  & .item {
    margin: 10px 0px;
    display: flex;
    align-items: center;
  }
  & .attention {
    display: flex;
    align-items: center;
    padding: 15px;
    background: #eaf2ff;
    border: 1px solid #cbdfff;
    border-radius: 10px;
  }
`;

export const Footer = styled.div`
  padding: 20px 0 40px 0;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  justify-content: center;
  align-items: center;

  & .cancel-btn {
    width: 120px;
    cursor: pointer;
    height: 42px;
    border: none;
    color: #485ea8;
    outline: none;
    background: linear-gradient(157.48deg, #ffffff -5.34%, #ffffff 103.65%);
    box-shadow: 0px 5px 15px rgba(23, 40, 253, 0.333333);
    border-radius: 10px;
  }

  & .confirm-btn {
    width: 120px;
    cursor: pointer;
    height: 42px;
    border: none;
    color: #ffffff;
    outline: none;
    background: linear-gradient(157.48deg, #548feb -5.34%, #4d67c1 103.65%);
    box-shadow: 0px 5px 15px rgba(23, 40, 253, 0.333333);
    border-radius: 10px;
  }
`;

export const Label = styled.div`
  margin: 8px 0;
  @media only screen and (max-width: 500px) {
    & {
      display: flex;
      flex-direction: column;
    }
    & .name {
      min-width: 350px;
    }

    & .value {
      width: 100%;
    }
  }
  display: flex;

  & .name {
    width: 30%;
  }

  & .value {
    width: 70%;
    font-weight: 600;
  }
`;

export const ModalInput = styled(Input)`
  width: 70%;
  @media only screen and (max-width: 500px) {
    & {
      width: 100%;
    }
  }

  padding: 10px 0px 10px 20px;
  box-shadow: 0px 10px 30px 0px rgba(77, 103, 193, 0.149);
  height: 50px;
  background: #ffffff;
  border: none;
  box-sizing: border-box;
  border-radius: 16px;
  margin: 0px 0px;

  &::placeholder {
    color: #a3a3a3;
    opacity: 1;
  }

  &:-ms-input-placeholder {
    color: #a3a3a3;
  }

  &::-ms-input-placeholder {
    color: #a3a3a3;
  }
`;
